import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectConstants } from '../project-constants';

@Component({
  selector: 'app-grievance-exist-dialog',
  templateUrl: './grievance-exist-dialog.component.html',
  styleUrls: ['./grievance-exist-dialog.component.scss'],
})
export class GrievanceExistDialogComponent implements OnInit {
title=ProjectConstants.grievanceExistTitle
dialogMsg=ProjectConstants.grievanceExistTitleMsg
okMsg=ProjectConstants.okMsg
cancelbtnMsg=ProjectConstants.cancelBtn
  constructor(
    public dialogRef: MatDialogRef<GrievanceExistDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {}


  onNoClick(){
    // this.dialogRef.close();
    this.dialogRef.close('No');
  }
  OkClick(){
    this.dialogRef.close('Yes');
  }
}
